<template>
  <v-container>
    <v-row>
      <v-spacer/>
      <v-col cols="12" md="6">
        <v-text-field
          label="Name"
          v-model="characterName"
        />
      </v-col>
      <v-spacer/>
    </v-row>

    <v-row>
    </v-row>
  </v-container>
</template>

<script>

export default {
  data() {
    return {}
  },
  computed: {
    characterName: {
      get() {
        return this.$store.state.character.name;
      },
      set(val) {
        this.$store.dispatch('character/setName', val);
      },
    },
  },
}

</script>
